var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "renderer" },
    [
      _vm.object.status === "verified"
        ? _c("UiBadge", { attrs: { type: "success" } }, [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("remoteMonitoring.validation.verified")) +
                "\n  "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.object.status === "waiting"
        ? _c("UiBadge", { attrs: { type: "info" } }, [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("remoteMonitoring.validation.waiting")) +
                "\n  "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.object.status === "refused"
        ? _c("UiBadge", { attrs: { type: "danger" } }, [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("remoteMonitoring.validation.refused")) +
                "\n  "
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }